/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'semantic-ui-react';

import { setInitialValues } from './utils/form-utils';
import { Field, Formik } from 'formik';
import { TextAreaField, InputField } from './fields';
import { ActionsSection } from './buttons/actions-section';
import { DropdownField } from './fields/dropdown-field';
import { saveControlBoxAC } from '../../action-creators';

// No `secret`: a site is not a device that logs in, so it has none.
const FIELDS = ['name', 'mode', 'uuid', 'timeZone', 'logLevel', 'ticketFormat', 'ticketFormatTemplateCode'];

function ControlBoxForm(props: any) {
  const { dispatch, onClose } = props;
  const boundHandleSubmit = (values: any, formikActions: any) =>
    dispatch(saveControlBoxAC({ data: values, formikActions, closeDialog: onClose }));
  return (
    <Formik initialValues={setInitialValues(FIELDS, props)} onSubmit={boundHandleSubmit}>
      {({ values, handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Field name="name" label="Name" component={InputField} />
          <Field name="uuid" label="UUID" component={InputField} disabled={!!values.id} />
          <Field name="ticketFormatTemplateCode">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Template Code"
                options={[
                  { value: '', text: 'Auto' },
                  { value: 'cz', text: 'cz' },
                  { value: 'sk', text: 'sk' },
                  { value: 'en', text: 'en' },
                  { value: 'cz-en', text: 'cz-en' }
                ]}
              />
            )}
          </Field>
          <Field name="ticketFormat" label="Ticket template" component={TextAreaField} />
          <Field name="mode">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Run Mode"
                options={[
                  { value: 'cloud', text: 'Running in cloud' },
                  { value: 'onPremise', text: 'Running on premise' }
                ]}
              />
            )}
          </Field>
          <Field name="logLevel">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Log level"
                options={[
                  { value: 'trace', text: 'Trace' },
                  { value: 'debug', text: 'Debug' },
                  { value: 'info', text: 'Info' },
                  { value: 'warn', text: 'Warning' },
                  { value: 'error', text: 'Error' },
                  { value: 'fatal', text: 'Fatal' }
                ]}
              />
            )}
          </Field>
          <Field name="timeZone">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Time zone"
                options={[
                  { value: 'Europe/Prague', text: 'Europe/Prague' },
                  { value: 'Europe/Bratislava', text: 'Europe/Bratislava' }
                ]}
              />
            )}
          </Field>
          <ActionsSection isNew={!values.id} disabled={isSubmitting} onCancel={props.onClose} />
        </Form>
      )}
    </Formik>
  );
}

const ConnectedComponent = connect((state: any) => ({
  app: state.app,
  serviceProviders: state.serviceProviders,
  controlBoxes: state.controlBoxes
}))(ControlBoxForm);

export default ConnectedComponent;
